export const tagStyle = {
  alignItems: 'center',
  margin: '3px 6px 3px 0',
};
